const PostRenderer = {};

function customWidthSinglePrices($element) {
  $element.find('.item').each(function() {
    const $this = $(this);
    const $prices = $this.find('.price-entry');
    if ($prices.length === 1) {
      $prices.eq(0).css('width', '');
      $this.find('.cloned-price').find('span').css('width', '');
    }
  });
}

PostRenderer['price-list-compact'] = customWidthSinglePrices;
PostRenderer['price-list'] = customWidthSinglePrices;
PostRenderer['after-description-price-list'] = customWidthSinglePrices;

export default PostRenderer;
